import React from 'react';
import {
  Box,
  List,
  ListSubheader,
  makeStyles,
  InputLabel,
} from '@material-ui/core';
import ListItems from './ListItems';

const useStyles = makeStyles((theme) => ({
  subheader: {
    fontSize: 18,
    fontWeight: 'bold',
    textAlign: 'center',
    color: '#323232',
    margin: 0,
    padding: 0,
    [theme.breakpoints.up('sm')]: {
      fontSize: 22,
    },
  },
  petLabel: {
    paddingLeft: 15,
  },
  petInput: {
    width: '95%',
    margin: 'auto',
    borderBottom: '1px solid black',
    position: 'relative',
    fontSize: 20,
    padding: '10px 0',
  },
  petImg: {
    position: 'absolute',
    bottom: 0,
    right: 0,
    height: 55,
  },
}));

export default function PersonalInfoCard({
  userData,
  carData,
  insuranceName,
  techData,
  petData,
  taxIVA,
  taxIIBB,
  activityName,
}) {
  const classes = useStyles();

  const subHeader = () => {
    if (insuranceName === ('INTEGRAL DE COMERCIO' || 'HOGAR')) {
      return 'Datos del domicilio asegurado';
    } else if (insuranceName === 'AUTOMOTOR') {
      return 'Datos del auto asegurado';
    } else {
      return 'Datos del asegurado';
    }
  };

  return (
    <Box
      width='100%'
      display='flex'
      justifyContent='center'
      bgcolor='#f5f8fa'
      px={{ xs: '20px', sm: '40px' }}
      py='20px'
    >
      <List
        component='div'
        disablePadding
        subheader={
          <ListSubheader
            disableSticky
            component='p'
            classes={{ root: classes.subheader }}
          >
            {subHeader()}
          </ListSubheader>
        }
        style={{ width: '100%' }}
      >
        {petData && (
          <>
            <InputLabel classes={{ root: classes.petLabel }}>
              Nombre de la mascota
            </InputLabel>
            <div className={classes.petInput}>
              {petData.name}
              <img
                className={classes.petImg}
                src={require(`./../../img/${petData.type.toLowerCase()}-azul.svg`)}
                alt={'imagen de mascota'}
              />
            </div>
          </>
        )}
        <ListItems
          userData={userData}
          carData={carData}
          insuranceName={insuranceName}
          techData={techData}
          taxIVA={taxIVA}
          taxIIBB={taxIIBB}
          activityName={activityName}
        />
      </List>
    </Box>
  );
}
